import { FC } from 'react';
import { AuthModalProps } from './AuthModal.props';
import AuthModalView from './AuthModal.view';

const AuthModalContainer: FC<AuthModalProps> = ({
  isOpen = false,
  onClose,
  redirectUrl,
}) => {
  return (
    <AuthModalView
      isOpen={isOpen}
      onClose={onClose}
      redirectUrl={redirectUrl}
    />
  );
};

export default AuthModalContainer;
